import {
  Alert,
  AppBar,
  Breadcrumbs,
  Chip,
  Container,
  emphasize,
  styled,
  Toolbar,
  Link as MuiLink,
  Button,
} from "@mui/material";
import { useRef } from "react";
import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, Grid, Typography } from "@mui/material";
import { AppFilter } from "../../models/app/AppModels";
import PageLoader from "../app/PageLoader";
import { DmsLocations } from "../../models/auth/Auth";
import { PartsCheckoutInitialValues } from "../../models/features/Gravity/CheckoutDetail";
import {
  addToCart,
  useGetDmsPartsMutation,
  useAddToCartPartMutation,
} from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import {
  DmsCategory,
  DmsManufacturer,
} from "../../models/features/ShoppingPortal/DmsManufacturer";
import {
  DmsPart,
  DmsPartRequestDto,
} from "../../models/features/ShoppingPortal/DmsPart";
import {
  capitalizeFirstLetter,
  getPartPrice,
} from "../../services/utilities/utility";
import { PartsList } from "./Common/PartsList";
import { PartsListFilter } from "./Common/PartsListFilter";
import HomeIcon from "@mui/icons-material/Home";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FactoryIcon from "@mui/icons-material/Factory";
import { useNavigate } from "react-router-dom";
import SnackBarPopup from "../app/SnackBarPopup";

declare const emergepay: any;
export const EmbeddedParts: React.FunctionComponent = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  let mfrCode = urlSearchParams.get("mfrCode");
  let mfrName = urlSearchParams.get("mfrName");

  let categoryId = urlSearchParams.get("categoryId");
  let catName = urlSearchParams.get("catName");
  const [cartAlert, setCartAlert] = React.useState(false);
  const [diplayFilter, setDiplayFilter] = React.useState(
    mfrCode !== null ? false : true
  );
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 20,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const navigate = useNavigate();
  const [isLoadingParts, setIsLoadingParts] = React.useState(false);
  const dispatch = useDispatch();
  const dmsLocations = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.dmsLocations
  );
  const hideMfgs = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting?.hideMfgs
  );
  const rules = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.settingRules
  );
  const { customerData } = useSelector((state: AppState) => state.authReducer);
  const setupId = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting.dmsSetupId
  );

  const storeUrl = useSelector(
    (state: AppState) => state.shoppingPortalReducer.storeUrl
  );

  const dmsDealerId = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.dmsDealerId
  );
  const pricing = useSelector(
    (state: AppState) => state.shoppingPortalReducer.portalSettings?.pricing
  );
  const activeCategoryFilter = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting?.activeCategoryFilter
  );
  const activeManufacturerFilter = useSelector(
    (state: AppState) =>
      state.shoppingPortalReducer.portalSettings?.setting
        ?.activeManufacturerFilter
  );
  const [getDmsPartsMutation, getDmsPartsMutationResult] =
    useGetDmsPartsMutation();

  const [addToCartPartMutation, addToCartPartResult] =
    useAddToCartPartMutation();

  const [dmsParts, setDmsParts] = useState<DmsPart[]>([]);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [selectedManufacturers, setSelectedManufacturers] = useState<string[]>(
    mfrCode !== null ? [mfrCode] : []
  );
  const [selectedLocations, setSelectedLocations] = React.useState<
    DmsLocations[]
  >([]);
  const [partsCheckoutDetail, setPartsCheckoutDetail] = React.useState<any>(
    PartsCheckoutInitialValues
  );
  const [selectedCategories, setSelectedCategories] = useState<string[]>(
    categoryId !== null ? [categoryId] : []
  );

  const [search, setSearch] = useState("");
  const [isLoading, setIsLoading] = React.useState(false);

  const isMounted1 = useRef(false);
  const isMounted2 = useRef(false);

  useEffect(() => {
    if (customerData && customerData.email) {
      setPartsCheckoutDetail({
        ...partsCheckoutDetail,
        billingName: customerData.displayName,
        email: customerData.email,
        phone: customerData.phone,
      });
    }
  }, [customerData]);

  const fetchDmsPartsData = () => {
    setIsLoadingParts(true);
    var partNotIncludedRules = rules?.filter((rule) => rule.hideParts) ?? [];
    let notIncludedParts = partNotIncludedRules.flatMap(
      (rule) => rule.partNumbers || []
    );
    var data: DmsPartRequestDto = {
      dealerIds:
        selectedLocations.length > 0
          ? selectedLocations.map((loc) => loc.dealerId.toString())
          : dmsLocations
              ?.filter((n) => n.shopifyLocationId > 0)
              .map((n: any) => n.dealerId.toString()) ?? [],
      pageSize: paging.pageSize,
      pageNumber: paging.pageIndex,
      stockingOnly: true,
      searchPartNumber: [],
      searchPartDescription: "",
      search: search,
      searchManufacturerId: "",
      searchManufacturerCode: selectedManufacturers.map((mfg) =>
        mfg.toString()
      ),
      categoryIds: selectedCategories.map((cat) => cat.toString()),
      searchManufacturerCodeNotIn: hideMfgs ?? [],
      inventoryPartIdNotIn: notIncludedParts,
    };

    getDmsPartsMutation({ data: data })
      .then((response: any) => {
        if (response?.data && response?.data?.entityList !== null) {
          var partsResponse = response?.data?.entityList?.map((item: any) => ({
            ...item,
            price: getPartPrice(item, pricing),
          }));
          if (paging.pageIndex > 0) {
            setDmsParts([...dmsParts, ...partsResponse]);
          } else {
            setDmsParts(partsResponse);
            setTotalRecords(response.data.totalRecords);
          }
        }
      })
      .catch((error) => {})
      .finally(() => {
        setIsLoadingParts(false);
      });
  };
  const fetchMoreData = () => {
    setPaging({ ...paging, pageIndex: paging.pageIndex + 1 });
  };

  React.useEffect(() => {
    if (dmsLocations !== undefined && dmsDealerId !== undefined) {
      fetchDmsPartsData();
    }
  }, [dmsDealerId]);

  React.useEffect(() => {
    if (
      dmsLocations !== undefined &&
      dmsDealerId !== undefined &&
      isMounted1.current
    ) {
      fetchDmsPartsData();
    } else {
      isMounted1.current = true;
    }
  }, [paging]);

  React.useEffect(() => {
    if (isMounted2.current) {
      if (dmsLocations !== undefined && dmsDealerId !== undefined) {
        setPaging({ ...paging, pageIndex: 0 });
        setDmsParts([]);
      }
    } else {
      isMounted2.current = true;
    }
  }, [selectedLocations, selectedManufacturers, selectedCategories]);

  const handleAddToCart = (part: DmsPart) => {
    setIsLoading(true);
    addToCartPartMutation({ dmsSetupId: setupId ?? "", part: part }).then(
      (res) => {
        window.parent.postMessage(
          res,
          document.location.ancestorOrigins.length > 0
            ? document.location.ancestorOrigins[0]
            : ""
        );
      }
    );
  };

  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data.eventType === "itemAddedTocart") {
        setIsLoading(false);
        setCartAlert(true);
      }
    });
  }, []);

  return (
    <>
      <Container maxWidth="xl">
        <PageLoader isLoading={!dmsLocations || isLoading}></PageLoader>
        <Grid container>
          <Grid item md={12}>
            <Box minHeight={100} bgcolor={"#f3f3f3"}>
              <Grid container md={12}>
                <Grid p={5} md={6} item>
                  <Typography variant="h4" fontWeight="bold">
                    Part Finder
                  </Typography>
                </Grid>
                <Grid md={6} item p={5}>
                  <Box sx={{ display: "flex", gap: 2, float: "right" }}>
                    Filter By:
                    {activeManufacturerFilter && (
                      <MuiLink
                        onClick={() =>
                          navigate(
                            `/ShoppingPortal/PartsByManuacturer?store=${storeUrl}`
                          )
                        }
                        color="inherit"
                        underline="none"
                        style={{ cursor: "pointer" }}
                      >
                        <strong>Manufacturer</strong>
                      </MuiLink>
                    )}
                    {activeCategoryFilter && (
                      <MuiLink
                        onClick={() => {
                          setSelectedManufacturers([]);
                          setDiplayFilter(true);
                          navigate(
                            `/ShoppingPortal/PartsByCategory?store=${storeUrl}`
                          );
                        }}
                        color="inherit"
                        underline="none"
                        style={{ cursor: "pointer" }}
                      >
                        <strong>Category</strong>
                      </MuiLink>
                    )}
                    <MuiLink
                      onClick={() => {
                        setSelectedManufacturers([]);
                        setDiplayFilter(true);
                        navigate(
                          `/ShoppingPortal/EmbeddedParts?store=${storeUrl}`
                        );
                      }}
                      color="inherit"
                      underline="none"
                      style={{ cursor: "pointer" }}
                    >
                      <strong>Search Filters</strong>
                    </MuiLink>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          {mfrCode !== null && (
            <Grid item md={12} mt={2}>
              <Breadcrumbs aria-label="breadcrumb">
                <StyledBreadcrumb
                  component="a"
                  label="Manufacturers"
                  icon={<FactoryIcon fontSize="small" />}
                  onClick={() =>
                    navigate(
                      `/ShoppingPortal/PartsByManuacturer?store=${storeUrl}`
                    )
                  }
                />
                <StyledBreadcrumb
                  label={capitalizeFirstLetter(mfrName !== null ? mfrName : "")}
                  deleteIcon={<ExpandMoreIcon />}
                />
              </Breadcrumbs>
            </Grid>
          )}

          {categoryId !== null && (
            <Grid item md={12} mt={2}>
              <Breadcrumbs aria-label="breadcrumb">
                <StyledBreadcrumb
                  component="a"
                  label="Categories"
                  icon={<FactoryIcon fontSize="small" />}
                  onClick={() =>
                    navigate(
                      `/ShoppingPortal/PartsByCategory?store=${storeUrl}`
                    )
                  }
                />
                <StyledBreadcrumb
                  label={capitalizeFirstLetter(catName !== null ? catName : "")}
                  deleteIcon={<ExpandMoreIcon />}
                />
              </Breadcrumbs>
            </Grid>
          )}

          <Grid item md={12}>
            <Grid container mt={2} mb={5}>
              <Grid item xs={12} md={3}>
                <PartsListFilter
                  isLoading={getDmsPartsMutationResult.isLoading}
                  setPaging={setPaging}
                  selectedManufacturers={selectedManufacturers}
                  setSelectedManufacturers={setSelectedManufacturers}
                  selectedLocations={selectedLocations}
                  setSelectedLocations={setSelectedLocations}
                  setSearch={setSearch}
                  search={search}
                  selectedCategories={selectedCategories}
                  setSelectedCategories={setSelectedCategories}
                ></PartsListFilter>
              </Grid>

              <Grid item xs={12} md={9}>
                <PartsList
                  fetchMoreData={fetchMoreData}
                  handleAddToCart={(item: any) => {
                    handleAddToCart(item);
                  }}
                  isLoadingParts={isLoadingParts}
                  parts={dmsParts}
                  totalRecords={totalRecords}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <SnackBarPopup
        severity="success"
        message="Added to your cart!"
        onClose={() => setCartAlert(false)}
        open={cartAlert}
        autoHideDuration={3000}
        verticalPosition="top"
      ></SnackBarPopup>
    </>
  );
};

export const searchOptions = {
  types: ["address"],
};

export const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    "&:hover, &:focus": {
      backgroundColor: emphasize(backgroundColor, 0.06),
    },
    "&:active": {
      boxShadow: theme.shadows[1],
      backgroundColor: emphasize(backgroundColor, 0.12),
    },
  };
}) as typeof Chip; // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591
